import Phaser from 'phaser';
import type { GameMode } from '../types';
import { titleStyle } from './MenuScene';
import { configureLogicalCamera } from '../systems/DisplayManager';

interface GameOverData { mode: GameMode; levelIndex: number; score: number }

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super('GameOver');
  }

  create(data: GameOverData): void {
    configureLogicalCamera(this);
    this.add.rectangle(240, 135, 480, 270, 0x07111e);
    for (let i = 0; i < 18; i += 1) {
      this.add.circle(24 + (i * 47) % 450, 30 + (i * 37) % 220, 3 + (i % 5), 0x5cccd4, 0.15 + (i % 3) * 0.1);
    }
    this.add.text(240, 74, 'BĄBLE PRYSŁY…', titleStyle(20, '#e26960')).setOrigin(0.5).setStroke('#321d2b', 5);
    this.add.text(240, 113, `ETAP ${data.levelIndex + 1}   WYNIK ${data.score}`, titleStyle(9, '#f6e5b6')).setOrigin(0.5);
    const retry = this.add.text(240, 158, '[ ENTER ] SPRÓBUJ PONOWNIE', {
      ...titleStyle(10, '#8fe17f'),
      backgroundColor: '#153c3add',
      padding: { x: 12, y: 9 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    const menu = this.add.text(240, 199, '[ ESC ] MENU', titleStyle(9, '#efc65d')).setOrigin(0.5).setInteractive({ useHandCursor: true });
    const restart = () => this.scene.start('Game', { ...data, multiplier: 1 });
    retry.on('pointerdown', restart);
    menu.on('pointerdown', () => this.scene.start('Menu'));
    this.input.keyboard?.once('keydown-ENTER', restart);
    this.input.keyboard?.once('keydown-ESC', () => this.scene.start('Menu'));
  }
}
